declare const require: any;
export const environment = {
  production: true,
  baseUrl: 'webpay/backoffice',
  environment: 'prod',
  version: require('../../package.json').version,
  epayUrl: 'https://paycenter.piraeusbank.gr/redirection/pay.aspx',
};
